import admin from '@/router/middlewares/admin';

export const Index = r => require.ensure([], () => r(require('./index')), 'users-bundle');

export default [
  {
    path: 'users',
    name: 'users',
    component: Index,
    meta: {
      middleware: [admin]
    }
  }
];
